import React, { useContext } from "react";
import { Control } from "react-hook-form";
import { DeleteModalFieldset } from "../AddressPanel/Header/__styles__/DeletePropertyModal";
import { AuthContext } from "../Authorization/AuthContext";
import { Checkbox } from "../Inputs/react-hook-form";
import { Body } from "./Typography";

export interface DeleteConfirmationForm {
  confirmFileDelete: boolean;
  confirmDashboardRemoval: boolean;
  confirmPublicWebsiteRemoval?: boolean;
}

interface DeleteObjectContentProps {
  objectType: string;
  control: Control<DeleteConfirmationForm>;
}

export const DeleteObjectContent = ({
  objectType,
  control,
}: DeleteObjectContentProps) => {
  const { account } = useContext(AuthContext);

  return (
    <>
      <Body size="default" type="regular">
        By deleting the selected {objectType}, you confirm that:
      </Body>
      <DeleteModalFieldset>
        <Checkbox
          control={control}
          required={true}
          name="confirmFileDelete"
          label={`All associated data with the ${objectType} will be deleted.`}
        />
        <Checkbox
          control={control}
          required={true}
          name="confirmDashboardRemoval"
          label={`The ${objectType} will be removed from the dashboard for all users.`}
        />
        {account?.publicPortal.enabled && (
          <Checkbox
            control={control}
            required={true}
            name="confirmPublicWebsiteRemoval"
            label={`The ${objectType} will no longer be accessible from your public website.`}
          />
        )}
      </DeleteModalFieldset>
      <Body size="default" type="regular">
        This action <strong>cannot</strong> be undone.
      </Body>
    </>
  );
};
